module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("If witches could do any such miraculous things,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("as these and other which are imputed to them,")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("they might do them again and again,")]), _vm._v(" "), _c('p', {
    staticClass: "ep-bot"
  }, [_vm._v("at any time or place, or at any man’s desire.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("—Reginald Scot")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("The Discoverie of Witchcraft,")]), _vm._v(" "), _c('span', {
    staticClass: "epub-b"
  }, [_vm._v("1584")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0